var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "340px",
    height: "190px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 51.09 28.55",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil0 {fill:#005F87}\r\n    .fil7 {fill:#00AAAD}\r\n    .fil10 {fill:#267A8C}\r\n    .fil1 {fill:#3A4553}\r\n    .fil13 {fill:#3AA9AE}\r\n    .fil15 {fill:#424C5C}\r\n    .fil11 {fill:#C4337C}\r\n    .fil4 {fill:#E1E1E1}\r\n    .fil5 {fill:#E9E9E9}\r\n    .fil14 {fill:#EBF0F5}\r\n    .fil12 {fill:#F2F2F2}\r\n    .fil16 {fill:#FAD55A}\r\n    .fil8 {fill:#FAFAFA}\r\n    .fil2 {fill:#FC6D39}\r\n    .fil17 {fill:#FDFDFD}\r\n    .fil9 {fill:#FFB800}\r\n    .fil6 {fill:white}\r\n    .fil3 {fill:white;fill-opacity:0.019608}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 51.09,
    height: 28.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M17.72 6.61l17.59 0c0.79,0 1.44,0.64 1.44,1.41l0 10.91 -20.47 0 0 -10.91c0,-0.77 0.65,-1.41 1.44,-1.41z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 16.75,
    y: 8.44,
    width: 19.66,
    height: 1.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M17.72 6.61l17.59 0c0.79,0 1.44,0.64 1.44,1.41l0 10.91 -20.47 -10.91c0,-0.77 0.65,-1.41 1.44,-1.41z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "23.14,21.98 30.65,23.76 29.92,21.34 23.1,21.19 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M37.12 18.93l0 1.64c0,0.48 -0.41,0.88 -0.91,0.88l-19.25 0c-0.5,0 -0.91,-0.4 -0.91,-0.88l0 -1.64 21.07 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M37.12 8.44l0 -0.95c0,-0.48 -0.41,-0.88 -0.91,-0.88l-19.25 0c-0.5,0 -0.91,0.4 -0.91,0.88l0 0.95 21.07 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5",
    x: 36.42,
    y: 8.02,
    width: 0.7,
    height: 11.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6",
    x: 25.17,
    y: 3.67,
    width: 10.3,
    height: 7.25,
    rx: 0.55,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M25.72 3.57l9.2 0c0.31,0 0.55,0.16 0.55,0.36l0 0.63 -10.3 0 0 -0.63c0,-0.2 0.25,-0.36 0.55,-0.36z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2001224437040"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M34.27 13.67l-0.16 0c-0.03,-0.05 -0.06,-0.1 -0.09,-0.14l0.07 -0.14c0.03,-0.06 0.01,-0.14 -0.05,-0.18l-0.16 -0.11c-0.03,-0.02 -0.07,-0.03 -0.1,-0.02 -0.03,0 -0.06,0.02 -0.08,0.04l-0.11 0.11c-0.05,-0.02 -0.11,-0.03 -0.17,-0.04l-0.05 -0.14c-0.02,-0.07 -0.09,-0.11 -0.15,-0.09l-0.2 0.03c-0.06,0.01 -0.11,0.07 -0.11,0.14l0 0.16c-0.05,0.02 -0.1,0.05 -0.14,0.09l-0.14 -0.07c-0.03,-0.01 -0.06,-0.02 -0.09,-0.01 -0.03,0 -0.07,0.02 -0.09,0.05l-0.11 0.17c-0.04,0.05 -0.03,0.13 0.02,0.17l0.11 0.12c-0.02,0.05 -0.03,0.1 -0.03,0.16l-0.15 0.05c-0.07,0.03 -0.1,0.09 -0.09,0.16l0.03 0.19c0.01,0.07 0.07,0.12 0.14,0.12l0.16 0c0.03,0.04 0.06,0.09 0.09,0.13l-0.07 0.15c-0.03,0.06 -0.01,0.13 0.05,0.17l0.16 0.11c0.03,0.02 0.07,0.03 0.1,0.03 0.03,-0.01 0.06,-0.02 0.08,-0.04l0.11 -0.12c0.05,0.02 0.1,0.03 0.16,0.04l0.05 0.15c0.02,0.06 0.09,0.1 0.15,0.09l0.2 -0.04c0.07,-0.01 0.11,-0.07 0.11,-0.13l0 -0.16c0.05,-0.03 0.1,-0.06 0.14,-0.09l0.15 0.07c0.02,0.01 0.05,0.01 0.08,0.01l0 0c0.04,-0.01 0.07,-0.03 0.09,-0.06l0.11 -0.16c0.04,-0.06 0.03,-0.13 -0.01,-0.18l-0.12 -0.11c0.02,-0.05 0.03,-0.11 0.04,-0.16l0.15 -0.06c0.06,-0.02 0.1,-0.08 0.09,-0.15l-0.04 -0.2c-0.01,-0.06 -0.06,-0.11 -0.13,-0.11zm0.05 0.33c0,0.01 -0.01,0.01 -0.01,0.01l-0.19 0.07c-0.02,0.01 -0.04,0.03 -0.04,0.06 -0.01,0.07 -0.02,0.14 -0.05,0.2 -0.01,0.03 0,0.05 0.02,0.07l0.14 0.14c0,0 0,0.01 0,0.02l-0.11 0.16c-0.01,0 -0.01,0 -0.01,0 -0.01,0 -0.01,0 -0.01,0l-0.18 -0.08c-0.02,-0.01 -0.05,-0.01 -0.07,0.01 -0.05,0.04 -0.11,0.08 -0.18,0.11 -0.02,0.01 -0.03,0.03 -0.03,0.06l0 0.2c0,0 -0.01,0.01 -0.01,0.01l-0.2 0.03c0,0 -0.01,0 -0.01,0l-0.07 -0.19c-0.01,-0.03 -0.03,-0.04 -0.05,-0.04 -0.07,-0.01 -0.14,-0.03 -0.2,-0.05 -0.02,0 -0.03,0 -0.04,0 -0.01,0 -0.02,0.01 -0.03,0.02l-0.14 0.14c0,0 -0.01,0 -0.01,0 0,0 0,0 -0.01,0l-0.16 -0.11c-0.01,-0.01 -0.01,-0.01 0,-0.02l0.08 -0.18c0.01,-0.02 0.01,-0.05 -0.01,-0.07 -0.04,-0.05 -0.08,-0.11 -0.11,-0.17 -0.01,-0.03 -0.04,-0.04 -0.06,-0.04l-0.2 0c-0.01,0 -0.01,0 -0.01,-0.01l-0.04 -0.19c0,-0.01 0,-0.02 0.01,-0.02l0.19 -0.06c0.02,-0.01 0.04,-0.03 0.04,-0.06 0,-0.07 0.02,-0.14 0.04,-0.21 0.01,-0.02 0.01,-0.05 -0.01,-0.06l-0.14 -0.15c-0.01,0 -0.01,-0.01 -0.01,-0.01l0.12 -0.16c0,-0.01 0,-0.01 0.01,-0.01 0,0 0,0 0,0l0.18 0.09c0.02,0.01 0.05,0.01 0.07,-0.01 0.05,-0.05 0.11,-0.09 0.18,-0.12 0.02,-0.01 0.04,-0.03 0.04,-0.05l-0.01 -0.2c0,-0.01 0.01,-0.02 0.02,-0.02l0.19 -0.03c0.01,0 0.01,0 0.01,0.01l0.07 0.18c0.01,0.03 0.03,0.04 0.05,0.05 0.08,0 0.15,0.02 0.22,0.04 0.02,0.01 0.05,0.01 0.06,-0.01l0.14 -0.14c0,-0.01 0.01,-0.01 0.01,-0.01 0,0 0,0 0.01,0l0.16 0.12c0.01,0 0.01,0.01 0,0.01l-0.08 0.18c-0.01,0.03 -0.01,0.05 0.01,0.07 0.04,0.06 0.08,0.12 0.11,0.18 0.01,0.02 0.04,0.04 0.06,0.04l0.2 0c0.01,0 0.01,0 0.01,0.01l0.04 0.19 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M33.23 13.6c-0.26,0.05 -0.44,0.3 -0.39,0.56 0.05,0.26 0.3,0.44 0.56,0.39 0.26,-0.04 0.44,-0.3 0.39,-0.56 -0.04,-0.26 -0.29,-0.44 -0.56,-0.39zm0.15 0.83c-0.19,0.03 -0.38,-0.1 -0.41,-0.29 -0.04,-0.2 0.09,-0.38 0.29,-0.42 0.19,-0.03 0.38,0.1 0.41,0.29 0.03,0.2 -0.1,0.38 -0.29,0.42z"
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("circle", {
    className: "fil9",
    cx: 36.02,
    cy: 19.92,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil10",
    cx: 34.89,
    cy: 19.92,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil11",
    cx: 33.81,
    cy: 19.92,
    r: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil12",
    points: "22.57,24 23.12,21.49 30.58,23.51 30.84,24.08 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5",
    x: 16.05,
    y: 8.14,
    width: 0.7,
    height: 11.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil13",
    cx: 19.27,
    cy: 9.12,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 18.4,
    cy: 9.12,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil15",
    cx: 17.56,
    cy: 9.12,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 26.4,
    cy: 4.06,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 25.81,
    cy: 4.06,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 27.02,
    cy: 4.06,
    r: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M30.93 6.08c0.2,0.01 0.42,0 0.62,0 0.11,0 0.18,-0.01 0.27,0.04 0.29,0.13 0.25,0.44 0.25,0.68l0 1.23c0,0.28 0.05,0.57 -0.21,0.73 -0.07,0.04 -0.14,0.06 -0.24,0.06 -0.2,0 -0.42,-0.01 -0.62,0 0.02,0.09 0.01,0.14 0,0.23 0.11,0.01 0.65,0.01 0.74,0 0.19,-0.03 0.34,-0.14 0.45,-0.29 0.13,-0.17 0.11,-0.37 0.11,-0.61l0 -1.48c0,-0.22 0.01,-0.41 -0.15,-0.59 -0.12,-0.14 -0.28,-0.23 -0.49,-0.24 -0.24,0 -0.5,0.02 -0.73,0 0.01,0.03 0.07,0.07 0.08,0.12 0,0.05 -0.06,0.08 -0.08,0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil16",
    d: "M30.27 6.52c0.04,0.02 0.06,0.08 0.13,0.08 0.04,0 0.04,-0.02 0.06,-0.04 0.01,-0.01 0.04,-0.04 0.05,-0.04 0.04,-0.07 0.12,-0.13 0.16,-0.17l0.15 -0.17c0.03,-0.02 0.08,-0.09 0.11,-0.1 0.02,-0.04 0.08,-0.07 0.08,-0.12 -0.01,-0.05 -0.07,-0.09 -0.08,-0.12l-0.11 -0.1c-0.03,-0.04 -0.06,-0.08 -0.1,-0.11 -0.02,-0.02 -0.03,-0.03 -0.05,-0.05l-0.15 -0.16c-0.03,-0.03 -0.08,-0.1 -0.12,-0.1 -0.05,0 -0.09,0.05 -0.13,0.09l-0.25 0.27c-0.02,0.02 -0.04,0.03 -0.06,0.05 -0.06,0.06 -0.07,0.09 -0.15,0.16 -0.01,0.01 -0.04,0.04 -0.04,0.07 0.01,0.05 0.16,0.19 0.2,0.23 0.03,0.04 0.06,0.08 0.1,0.11 0.04,0.04 0.07,0.07 0.1,0.11 0.04,0.04 0.09,0.08 0.1,0.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil13",
    d: "M28.82 7.59l0 -0.24c0,-0.32 0.06,-0.25 -0.61,-0.25 -0.18,0 -0.14,0.03 -0.14,0.37 0,0.34 -0.04,0.38 0.13,0.38l0.53 0c0.05,0 0.08,-0.03 0.09,-0.08 0,-0.06 0,-0.12 0,-0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M30.27 6.52l0 0.58 0.24 0 0 -0.58c-0.01,0 -0.04,0.03 -0.05,0.04 -0.02,0.02 -0.02,0.04 -0.06,0.04 -0.07,0 -0.09,-0.06 -0.13,-0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M28.82 7.59l0.52 0 0 -0.23c-0.1,0 -0.45,0.01 -0.52,-0.01l0 0.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil13",
    d: "M30.27 8.32c0.08,-0.01 0.16,-0.01 0.24,0l0 -0.47 -0.24 0 0 0.47z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "28.35,8.63 28.54,8.63 28.54,8.59 28.54,8.47 28.54,8.43 28.51,8.43 28.39,8.43 28.35,8.43 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "28.35,8.23 28.54,8.23 28.54,8.03 28.35,8.03 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "29.47,9.03 29.65,9.03 29.65,8.84 29.47,8.84 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "29.1,9.03 29.28,9.03 29.28,8.84 29.1,8.84 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "28.73,9.03 28.91,9.03 28.92,8.84 28.73,8.84 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "28.35,9.03 28.53,9.03 28.53,8.84 28.35,8.84 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 29.24,
    y: 7.1,
    width: 2.2,
    height: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 30.39,
    cy: 7.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 30.1,
    cy: 7.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 30.7,
    cy: 7.5,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil11",
    cx: 30.39,
    cy: 8.96,
    r: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6",
    x: 10.2,
    y: 10.77,
    width: 10.3,
    height: 7.25,
    rx: 0.55,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M10.75 10.68l9.21 0c0.3,0 0.55,0.16 0.55,0.36l0 0.62 -10.31 0 0 -0.62c0,-0.2 0.25,-0.36 0.55,-0.36z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 11.44,
    cy: 11.16,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 10.85,
    cy: 11.16,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14",
    cx: 12.06,
    cy: 11.16,
    r: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M12.41 14.71c0.01,-0.24 0,-0.5 0,-0.74 0,-0.13 -0.01,-0.21 0.04,-0.32 0.16,-0.35 0.53,-0.29 0.81,-0.29l1.47 0c0.32,0 0.67,-0.07 0.86,0.24 0.05,0.09 0.07,0.17 0.07,0.29 0,0.24 -0.01,0.49 0,0.73 0.11,-0.02 0.17,-0.01 0.28,0 0,-0.13 0.01,-0.77 -0.01,-0.87 -0.03,-0.23 -0.16,-0.41 -0.33,-0.54 -0.21,-0.15 -0.44,-0.13 -0.74,-0.13l-1.74 0c-0.28,0 -0.5,-0.01 -0.7,0.17 -0.17,0.15 -0.29,0.34 -0.29,0.58 -0.01,0.29 0.01,0.6 0,0.88 0.02,-0.02 0.08,-0.09 0.13,-0.1 0.07,0 0.11,0.07 0.15,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil16",
    d: "M12.93 15.49c0.03,-0.05 0.1,-0.07 0.1,-0.15 0,-0.05 -0.03,-0.05 -0.05,-0.07 -0.01,-0.01 -0.05,-0.06 -0.05,-0.07 -0.08,-0.04 -0.15,-0.14 -0.2,-0.18l-0.2 -0.19c-0.03,-0.02 -0.1,-0.09 -0.12,-0.12 -0.04,-0.03 -0.08,-0.1 -0.15,-0.1 -0.05,0.01 -0.11,0.08 -0.13,0.1l-0.13 0.12c-0.04,0.04 -0.09,0.08 -0.13,0.12 -0.02,0.03 -0.03,0.04 -0.06,0.06l-0.19 0.19c-0.03,0.03 -0.11,0.08 -0.11,0.14 -0.01,0.05 0.05,0.1 0.1,0.15l0.32 0.3c0.02,0.02 0.04,0.04 0.06,0.06 0.08,0.08 0.11,0.1 0.19,0.18 0.02,0.02 0.05,0.05 0.09,0.05 0.06,0 0.22,-0.18 0.27,-0.23 0.04,-0.04 0.1,-0.08 0.13,-0.12 0.05,-0.05 0.08,-0.08 0.13,-0.12 0.05,-0.05 0.1,-0.11 0.13,-0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M12.93 15.49l0.69 0 0 -0.29 -0.69 0c0,0.01 0.04,0.06 0.05,0.07 0.02,0.02 0.05,0.02 0.05,0.07 0,0.08 -0.07,0.1 -0.1,0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M15.07 15.49c-0.01,-0.09 -0.02,-0.2 0,-0.28l-0.56 0 0 0.28 0.56 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M13.99 15.37c0.04,0.11 0.19,0.04 0.15,-0.06 -0.04,-0.08 -0.18,-0.04 -0.15,0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M13.99 15.69c0.03,0.1 0.18,0.06 0.15,-0.04 -0.03,-0.09 -0.18,-0.06 -0.15,0.04z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil13",
    x: 13.49,
    y: 14.79,
    width: 1.01,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil13",
    x: 18.23,
    y: 14.79,
    width: 1.01,
    height: 1.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "16.93,15.43 16.93,15.22 16.71,15.22 16.71,15.43 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "17.49,15.43 17.49,15.22 17.26,15.22 17.26,15.43 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "17.99,15.43 18,15.22 17.77,15.22 17.77,15.43 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil11",
    cx: 15.78,
    cy: 15.34,
    r: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1997547062272"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M32.46 15.58l-0.23 -0.04c-0.03,-0.08 -0.06,-0.15 -0.09,-0.22l0.13 -0.19c0.06,-0.08 0.05,-0.19 -0.02,-0.26l-0.2 -0.2c-0.04,-0.04 -0.09,-0.06 -0.15,-0.06 -0.04,0 -0.08,0.01 -0.11,0.04l-0.19 0.13c-0.08,-0.04 -0.15,-0.07 -0.23,-0.09l-0.04 -0.23c-0.02,-0.1 -0.1,-0.17 -0.2,-0.17l-0.28 0c-0.1,0 -0.19,0.07 -0.2,0.17l-0.04 0.23c-0.08,0.03 -0.15,0.06 -0.22,0.09l-0.19 -0.13c-0.03,-0.02 -0.08,-0.04 -0.12,-0.04 -0.05,0 -0.1,0.02 -0.14,0.06l-0.2 0.2c-0.07,0.07 -0.08,0.18 -0.03,0.26l0.14 0.19c-0.04,0.08 -0.07,0.15 -0.09,0.23l-0.23 0.04c-0.09,0.01 -0.16,0.1 -0.16,0.19l0 0.29c0,0.1 0.07,0.18 0.16,0.2l0.24 0.04c0.02,0.07 0.05,0.15 0.09,0.22l-0.14 0.19c-0.05,0.08 -0.04,0.19 0.03,0.25l0.2 0.21c0.04,0.04 0.09,0.06 0.14,0.06 0.04,0 0.08,-0.02 0.12,-0.04l0.19 -0.14c0.07,0.04 0.14,0.07 0.21,0.09l0.04 0.23c0.02,0.1 0.1,0.17 0.2,0.17l0.29 0c0.1,0 0.18,-0.07 0.2,-0.17l0.03 -0.23c0.08,-0.02 0.16,-0.05 0.23,-0.09l0.19 0.13c0.03,0.03 0.07,0.04 0.11,0.04l0 0c0.06,0 0.11,-0.02 0.14,-0.06l0.21 -0.2c0.07,-0.07 0.08,-0.18 0.02,-0.26l-0.14 -0.19c0.04,-0.07 0.07,-0.14 0.1,-0.22l0.22 -0.04c0.1,-0.01 0.17,-0.1 0.17,-0.2l0 -0.28c0,-0.1 -0.07,-0.19 -0.16,-0.2zm-0.02 0.48c0,0.01 -0.01,0.02 -0.01,0.02l-0.29 0.05c-0.04,0 -0.07,0.03 -0.07,0.07 -0.03,0.1 -0.07,0.19 -0.12,0.28 -0.02,0.03 -0.02,0.07 0,0.1l0.17 0.24c0,0 0,0.01 0,0.02l-0.21 0.2c0,0.01 0,0.01 -0.01,0.01 0,0 -0.01,0 -0.01,0l-0.23 -0.17c-0.03,-0.02 -0.07,-0.02 -0.1,-0.01 -0.09,0.06 -0.19,0.1 -0.29,0.12 -0.03,0.01 -0.06,0.04 -0.07,0.08l-0.04 0.28c-0.01,0.01 -0.01,0.02 -0.02,0.02l-0.29 0c-0.01,0 -0.02,-0.01 -0.02,-0.02l-0.04 -0.28c-0.01,-0.04 -0.04,-0.07 -0.07,-0.08 -0.1,-0.02 -0.19,-0.06 -0.28,-0.11 -0.01,-0.01 -0.03,-0.01 -0.05,-0.01 -0.01,0 -0.03,0 -0.05,0.01l-0.24 0.17c0,0 0,0.01 -0.01,0.01 0,0 -0.01,-0.01 -0.01,-0.01l-0.2 -0.2c-0.01,-0.01 -0.01,-0.02 -0.01,-0.03l0.17 -0.23c0.02,-0.03 0.02,-0.07 0.01,-0.1 -0.06,-0.09 -0.1,-0.19 -0.12,-0.29 -0.01,-0.03 -0.04,-0.06 -0.08,-0.06l-0.28 -0.05c-0.01,0 -0.02,-0.01 -0.02,-0.02l0 -0.29c0,0 0.01,-0.01 0.02,-0.01l0.28 -0.05c0.03,-0.01 0.06,-0.03 0.07,-0.07 0.03,-0.1 0.07,-0.2 0.12,-0.28 0.02,-0.04 0.02,-0.08 -0.01,-0.1l-0.16 -0.24c-0.01,-0.01 -0.01,-0.02 0,-0.03l0.2 -0.2c0,0 0.01,0 0.01,0 0.01,0 0.01,0 0.01,0l0.24 0.17c0.03,0.02 0.07,0.02 0.1,0 0.09,-0.05 0.18,-0.09 0.28,-0.12 0.04,-0.01 0.06,-0.04 0.07,-0.07l0.05 -0.29c0,-0.01 0.01,-0.01 0.02,-0.01l0.28 0c0.01,0 0.02,0 0.02,0.01l0.05 0.28c0,0.04 0.03,0.07 0.07,0.08 0.1,0.02 0.2,0.06 0.29,0.12 0.03,0.02 0.07,0.01 0.1,-0.01l0.23 -0.16c0.01,-0.01 0.01,-0.01 0.01,-0.01 0.01,0 0.01,0 0.02,0.01l0.2 0.2c0,0.01 0.01,0.02 0,0.02l-0.17 0.24c-0.02,0.03 -0.02,0.07 0,0.1 0.05,0.09 0.09,0.18 0.12,0.28 0.01,0.04 0.03,0.07 0.07,0.07l0.29 0.05c0,0 0.01,0.01 0.01,0.02l0 0.28 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M30.99 15.22c-0.38,0 -0.7,0.31 -0.7,0.7 0,0.39 0.32,0.7 0.7,0.7 0.39,0 0.71,-0.31 0.71,-0.7 0,-0.39 -0.32,-0.7 -0.71,-0.7zm0 1.22c-0.28,0 -0.51,-0.23 -0.51,-0.52 0,-0.29 0.23,-0.52 0.51,-0.52 0.29,0 0.52,0.23 0.52,0.52 0,0.29 -0.23,0.52 -0.52,0.52z"
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("rect", {
    className: "fil5",
    x: 20.7,
    y: 23.8,
    width: 11.87,
    height: 1.15,
    rx: 0.63,
    ry: 0.57
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCases);
export default __webpack_public_path__ + "static/media/use-cases.3a6ef2433f5c2e4d96c7cc6db3f576dc.svg";
export { ForwardRef as ReactComponent };